import script from "./SSOConnectionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SSOConnectionSettings.vue?vue&type=script&setup=true&lang=js"

import "./SSOConnectionSettings.vue?vue&type=style&index=0&id=778cc520&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778cc520"]])

export default __exports__